




































import { Component, Vue, Prop } from 'vue-property-decorator';
import { i18n } from '@/i18n';

@Component
export default class InfoCard extends Vue {
  @Prop({ default: () => [] }) public cols;
  @Prop({ default: () => [] }) public data;

  get age() {
    return i18n('歲', { age: this.data.age });
  }
}
